export default __webpack_public_path__ + "a49e000f5207df3ebd347a7b1c99ff22.png";